// Every adapter, called unconditionally once per orb render → models by id.
// Adapters read existing tool state (existing store → adapter → widget).
import { useEffect } from 'react';
import { publishOrbWidgets } from './bus';
import type { OrbWidgetModel, WidgetCtx } from './types';
import { useAtlasWidget } from './adapters/atlas';
import { useTelosWidget } from './adapters/telos';
import { useOracleWidget } from './adapters/oracle';
import { usePorosWidget } from './adapters/poros';
import { useNumaWidget } from './adapters/numa';
import { useMoyriWidget } from './adapters/moyri';
import { useHrmezWidget } from './adapters/hrmez';
import { useKyrsWidget } from './adapters/kyrs';
import { useKrnosWidget } from './adapters/krnos';
import { useTkneWidget } from './adapters/tkne';
import { useMetisWidget } from './adapters/metis';
import { useThemisWidget } from './adapters/themis';
import { useJanusWidget } from './adapters/janus';
import { useClioWidget } from './adapters/clio';
import { useArgosWidget } from './adapters/argos';
import { useNemosWidget } from './adapters/nemos';

export function useOrbWidgets(c: WidgetCtx): Record<string, OrbWidgetModel> {
  const list = [
    useAtlasWidget(c),
    useTelosWidget(c),
    useOracleWidget(c),
    usePorosWidget(c),
    useNumaWidget(c),
    useMoyriWidget(c),
    useHrmezWidget(c),
    useKyrsWidget(c),
    useKrnosWidget(c),
    useTkneWidget(c),
    useMetisWidget(c),
    useThemisWidget(c),
    useJanusWidget(c),
    useClioWidget(c),
    useArgosWidget(c),
    useNemosWidget(c),
  ];
  const models: Record<string, OrbWidgetModel> = {};
  for (const m of list) models[m.id] = m;
  useEffect(() => publishOrbWidgets(models));
  return models;
}
